/** Position geometry as the vendor prints it. Decimals cross the wire as strings. */
export type PressFormat = {
  width_mm: string;
  height_mm: string;
  // per edge ("+5 mm uz ārējām malām")
  bleed_mm: string | null;
};

/**
 * Product-level PRESS details. Empty controls normalize to null. Relation
 * absence is represented by the containing Product's `configuration: null`;
 * this object may remain present even when all four fields are null.
 */
export type PressConfig = {
  position: string | null;
  placement: string | null;
  section: string | null;
  format: PressFormat | null;
};

/** Distinct values already recorded against a vendor, offered as entry suggestions. */
export type PressAxes = {
  position: string[];
  placement: string[];
  section: string[];
};

export type PressAxisKey = keyof PressAxes;

/** Trim size as the sheet states it, `188 × 136`. Blank when there is no geometry. */
export function formatPressFormat(value: PressFormat | null): string {
  if (!value) {
    return '';
  }
  return `${value.width_mm} × ${value.height_mm}`;
}
